import { Button, SxProps, Theme } from '@mui/material';
import ShowMoreDrawer from 'pages/Dashboard/ShowMoreDrawer';
import ResolveInviteForm from 'pages/Dashboard/components/ResolveInviteForm';
import { INVITE_DRAWER_TYPE } from 'pages/Dashboard/enums';
import { PatientObj } from 'pages/Dashboard/types/patient.types';
import React, { memo, useCallback, useState } from 'react';
import { MixpanelEventName } from 'utils/constants';
import { trackMixpanelEvent } from 'utils/utilMethods';

interface TProps {
  patient: PatientObj;
  sx?: SxProps<Theme>
  btnText?: string;
}

function ResolveInvite({ patient, sx, btnText }: TProps) {
  const [drawerItem, setDrawerItem] = useState('');

  const openDrawer = useCallback(() => {
    trackMixpanelEvent(MixpanelEventName.RESOLVE_ERROR_BUTTON_CLICKED, {
      location: 'invite_errors_tab',
    });
    setDrawerItem(INVITE_DRAWER_TYPE.RESOLVE_INVITE);
  }, []);
  const closeDrawer = useCallback(() => {
    setDrawerItem('');
  }, []);

  return (
    <>
      <ShowMoreDrawer drawerItem={drawerItem} closeDrawer={closeDrawer}>
        <ResolveInviteForm
          patient={patient}
          drawerItem={drawerItem}
          closeDrawer={closeDrawer}
          drawerMode
        />
      </ShowMoreDrawer>
      <Button color='primary' variant='outlined' size='small' onClick={openDrawer} sx={sx}>
        {btnText || 'RESOLVE'}
      </Button>
    </>
  );
}

export default memo(ResolveInvite);
